// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3YEus","errorLogs":"EditorFooter_errorLogs__3543r"};